export const STUDENTLOGIN = 'STUDENTLOGIN';
export const STUDENTSIGNUP = 'STUDENTSIGNUP';
export const STUDENTPASSWORDFORGOT = 'STUDENTPASSWORDFORGOT';
export const STEP_STUDENTPROFILESINGUP = 'STUDENTPROFILESINGUP';
export const STEP_SCHOOLPROFILESIGNUP = 'SCHOOLPROFILESIGNUP';
export const STEP_PASSWORDSIGNUP = 'PASSWORDSIGNUP';